import React, { Fragment, useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
//impoertacion componentes

function CreaEquipoMejoramiento(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  const [postNombre, setPostNombre] = useState([]);
  const [postServicio, setPostServicio] = useState([]);
  const [postCargo, setPostCargo] = useState([]);
  const [postLider, setPostLider] = useState([]);
  const postData = (e) => {
    e.preventDefault(e);
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/CreaEquipoMejoramiento",
      data: {
        nombre: postNombre,
        servicio: postServicio,
        cargo: postCargo,
        lider: postLider,
        SolicitudId: props.idSolicitud,
      },
    })
      .then((Response) => {
        console.log(Response.data);
        alert(" añadido con exito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear Institucion " + error);
      });
  };
  return (
    <div className="test">
      <button
        variant="contained"
        className="btn btn-primary"
        color="primary"
        onClick={handleOpenModalTest}
      >
        {" "}
        Nueva
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
      >
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    Crear Equipo
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive"></div>
                  <form className="user">
                    <div className="form-group row">
                      <input
                        type="text"
                        className="form-control form-control-user"
                        placeholder="Nombre"
                        onChange={(e) => setPostNombre(e.target.value)}
                      />
                    </div>
                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <input
                          type="text"
                          className="form-control form-control-user"
                          placeholder="Equipo de Autoevalaución Que Representa"
                          onChange={(e) => setPostServicio(e.target.value)}
                        />
                      </div>
                      <div className="col-sm-6">
                        <input
                          type="text"
                          className="form-control form-control-user"
                          placeholder="Cargo"
                          onChange={(e) => setPostCargo(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-sm-12">
                        <select
                          className="btn btn-secondary btn-user btn-block"
                          onChange={(e) => setPostLider(e.target.value)}
                        >
                          <option value="">Es Lider?</option>
                          <option value="Si">SI</option>
                          <option value="No">NO</option>
                        </select>
                      </div>
                    </div>

                    <a>
                      <button
                        className="btn btn-primary btn-user btn-block"
                        onClick={postData}
                      >
                        Guardar
                      </button>
                    </a>
                    <hr />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}
export default CreaEquipoMejoramiento;
